// src/app/core/http/tutor.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@enviroment/environment';

export interface UpdateTutorPacienteRequest {
  idPaciente: string;
  idNuevoTutor: string;
}

@Injectable({ providedIn: 'root' })
export class TutorService {
  private readonly baseUrl = `${environment.backend_url}Tutores/`;

  constructor(private http: HttpClient) {}

  // =========================================
  // GET /api/Tutores/GetPacientesByTutor?idTutor=...
  // Si regresa lista vacía => NO es tutor
  // =========================================
  public getPacientesByTutor(idTutor: string): Observable<any[]> {
    const url = `${this.baseUrl}GetPacientesByTutor`;
    const params = new HttpParams().set('idTutor', idTutor);
    return this.http.get<any[]>(url, { params });
  }

  // =========================================
  // GET /api/Tutores/GetTutorByIdPaciente?idPaciente=...
  // =========================================
  public getTutorByPaciente(idPaciente: string): Observable<any> {
    const url = `${this.baseUrl}GetTutorByIdPaciente`;
    const params = new HttpParams().set('idPaciente', idPaciente);
    return this.http.get<any>(url, { params });
  }

  // =========================================
  // GET /api/Tutores/GetTutorByEmail?email=...
  // =========================================
  public getTutorByEmail(email: string): Observable<any> {
    const url = `${this.baseUrl}GetTutorByEmail`;
    const params = new HttpParams().set('email', email);
    return this.http.get<any>(url, { params });
  }

  // =========================================
  // PUT /api/Tutores/UpdateTutorPaciente
  // Body: { idPaciente, idNuevoTutor }
  // =========================================
  public updateTutorPaciente(payload: UpdateTutorPacienteRequest): Observable<any> {
    const url = `${this.baseUrl}UpdateTutorPaciente`;
    return this.http.put<any>(url, payload);
  }

  // =========================================
  // DELETE /api/Tutores/EliminarTutor?idPaciente=...
  // =========================================
  public eliminarTutor(idPaciente: string): Observable<any> {
    const url = `${this.baseUrl}EliminarTutor`;
    const params = new HttpParams().set('idPaciente', idPaciente);
    return this.http.delete<any>(url, { params });
  }
}
